import { EventReportTab } from '@components/event-linear-chart-section/src/event-linear-chart-section.type';
import {
  BarchartData,
  RECHART_LAYOUT_VERTICAL,
} from '@components/recharts-bar-chart-wrapper/src/recharts-bar-chart-wrapper.type';
import { Tab } from '@components/tabs/src/tabs.type';
import {
  OFFER_TYPE_ACTIVE_PASS,
  OFFER_TYPE_ADDON,
  OFFER_TYPE_BOTTLE_SERVICE,
  OFFER_TYPE_CHECKIN,
  OFFER_TYPE_GUEST_LIST,
  OFFER_TYPE_INACTIVE_PASS,
  OFFER_TYPE_INVITATION,
  OFFER_TYPE_PASS,
  OFFER_TYPE_TICKET,
} from '@constants/offer-types';
import {
  ADMISSION_TYPE_BOTTLE_SERVICE,
  ADMISSION_TYPE_GUEST_LIST,
  ADMISSION_TYPE_INVITATION,
  ADMISSION_TYPE_SEASON_PASS,
  ADMISSION_TYPE_TICKET,
} from '@domain/admission';
import { EventReportDataType } from '@domain/event-report';

import { colors } from '../../../../../tailwind-presets/tailwind-colors';

import { TableOfferReport } from './types';

/* CONFIG EVENT REPORT */
export const EVENT_REPORT_TICKET_TYPE = OFFER_TYPE_TICKET;
export const EVENT_REPORT_TICKET_COLOR = colors.purple[50];
export const EVENT_REPORT_BOTTLE_SERVICE_TYPE = OFFER_TYPE_BOTTLE_SERVICE;
export const EVENT_REPORT_BOTTLE_SERVICE_COLOR = colors.orange[50];
export const EVENT_REPORT_GUEST_LIST_TYPE = OFFER_TYPE_GUEST_LIST;
export const EVENT_REPORT_GUEST_LIST_COLOR = colors.pink[50];
export const EVENT_REPORT_PASS_TYPE = OFFER_TYPE_PASS;
export const EVENT_REPORT_ACTIVE_PASS_TYPE = OFFER_TYPE_ACTIVE_PASS;
export const EVENT_REPORT_INACTIVE_PASS_TYPE = OFFER_TYPE_INACTIVE_PASS;
export const EVENT_REPORT_PASS_COLOR = colors.turquoise[50];
export const EVENT_REPORT_INVITATION_TYPE = OFFER_TYPE_INVITATION;
export const EVENT_REPORT_CHECKIN_COLOR = colors.yellow[50];
export const EVENT_REPORT_CHECKIN_TYPE = OFFER_TYPE_CHECKIN;
export const EVENT_REPORT_INVITATION_COLOR = colors.blue[50];
export const EVENT_REPORT_TAB_TYPE_BOOKING = 'soldItems';
export const EVENT_REPORT_TAB_TYPE_REVENUE = 'revenue';
export const EVENT_REPORT_TAB_TYPE_ATTENDEES = 'attendees';
export const EVENT_REPORT_TAB_PRE_REGISTRATION = 'preregistrations';
export const EVENT_REPORT_TAB_TYPE_VIEWS = 'views';
export const EVENT_REPORT_ADDON_TYPE = OFFER_TYPE_ADDON;
export const EVENT_REPORT_ATTENDANCE_TYPE_ENTRY_TIME = 'entryTime';
export const EVENT_REPORT_ATTENDANCE_TYPE_RATE = 'rate';
export const EVENT_REPORT_ATTENDANCE_TYPE_ATTENDANCE = 'attendance';

export const EVENT_REPORT_PREREGISTRATION_STATUS_ENABLED = 'enabled';
export const EVENT_REPORT_PREREGISTRATION_STATUS_DISABLED = 'disabled';
export const EVENT_REPORT_PREREGISTRATION_STATUS_CLOSED = 'closed';

export const EVENT_REPORT_TYPES: EventReportDataType[] = [
  EVENT_REPORT_TICKET_TYPE,
  EVENT_REPORT_BOTTLE_SERVICE_TYPE,
  EVENT_REPORT_GUEST_LIST_TYPE,
  EVENT_REPORT_PASS_TYPE,
  EVENT_REPORT_INVITATION_TYPE,
  EVENT_REPORT_CHECKIN_TYPE,
];

export const EVENT_REPORT_COLORS = [
  EVENT_REPORT_TICKET_COLOR,
  EVENT_REPORT_BOTTLE_SERVICE_COLOR,
  EVENT_REPORT_GUEST_LIST_COLOR,
  EVENT_REPORT_PASS_COLOR,
  EVENT_REPORT_INVITATION_COLOR,
  EVENT_REPORT_CHECKIN_COLOR,
];

export const EVENT_REPORT_TAB_TIME_HOUR = 'hour';
export const EVENT_REPORT_TAB_TIME_DAY = 'day';
export const EVENT_REPORT_TAB_TIME_WEEK = 'week';

export const EVENT_REPORT_TAB_ADMISSION = 'admission';
export const EVENT_REPORT_TAB_ADDON = 'addon';
export const EVENT_REPORT_TAB_PASS = 'pass';
export const EVENT_REPORT_TAB_INVITATION = 'invitation';

export const EVENT_REPORT_MODE_TYPE_GRAPH = 'graph';
export const EVENT_REPORT_MODE_TYPE_LIST = 'list';

export const EVENT_REPORT_ATTENDEES_PARTIAL = 'partial_attended';
export const EVENT_REPORT_ATTENDEES_ALL = 'all_attended';

export const EVENT_REPORT_TABLE_NAME_COLUMN = 'name';
export const EVENT_REPORT_TABLE_PREGISTRATION_NAME_COLUMN = 'preRegistrationName';
export const EVENT_REPORT_TABLE_PRICE_COLUMN = 'price';
export const EVENT_REPORT_TABLE_BOOKINGS_COLUMN = 'bookings';
export const EVENT_REPORT_TABLE_STATUS_COLUMN = 'status';
export const EVENT_REPORT_TABLE_PRE_REGISTRATION_STATUS_COLUMN = 'preRegistrationStatus';
export const EVENT_REPORT_TABLE_REVENUE_COLUMN = 'revenue';
export const EVENT_REPORT_TABLE_DDP_COLUMN = 'ddp';
export const EVENT_REPORT_TABLE_ADDONS_COLUMN = 'addons';
export const EVENT_REPORT_TABLE_DOWNPAYMENT_COLUMN = 'downpayment';
export const EVENT_REPORT_TABLE_CHANNELS_COLUMN = 'channels';
export const EVENT_REPORT_TABLE_TOTAL_COLUMN = 'total';
export const EVENT_REPORT_TABLE_OFFER_COLUMN = 'offer';
export const EVENT_REPORT_TABLE_ATTENDEES_COLUMN = 'attendees';
export const EVENT_REPORT_TABLE_CONVERSION_COLUMN = 'conversion';
export const EVENT_REPORT_TABLE_QUANTITY_COLUMN = 'quantity';
export const EVENT_REPORT_TABLE_TIME_COLUMN = 'createdAt';
export const EVENT_REPORT_TABLE_HOLDERS_COLUMN = 'holders';
export const EVENT_REPORT_TABLE_ACTIONS_COLUMN = 'actions';
export const EVENT_REPORT_TABLE_REVENUE_PER_BOOKING_COLUMN = 'revenuePerBooking';
export const EVENT_REPORT_TABLE_SIGNUPS_COLUMN = 'signUps';
export const EVENT_REPORT_TABLE_CONVERSION_RATE_COLUMN = 'conversionRate';
export const EVENT_REPORT_TABLE_UNIQUE_BOOKINGS_COLUMN = 'uniqueBookings';
export const EVENT_REPORT_TABLE_TOTAL_BOOKINGS_COLUMN = 'totalBookings';

export const EVENT_REPORT_BOOKING_STATUS_ACTIVE = 'active';
export const EVENT_REPORT_BOOKING_STATUS_REFUNDED = 'refunded';
export const EVENT_REPORT_BOOKING_STATUS_RESOLD = 'resold';
export const EVENT_REPORT_BOOKING_STATUS_CANCELLED = 'cancelled';

export const EVENT_REPORT_BOOKING_FILTER_REFUND_PARAM = 'isRefunded';
export const EVENT_REPORT_BOOKING_FILTER_REFUND_TYPE = 'refunded';
export const EVENT_REPORT_BOOKING_FILTER_ACTIVE_TYPE = 'active';

export const EVENT_REPORT_BOOKING_FILTER_ATTENDANCE_PARAM = 'hasCheckedIn';
export const EVENT_REPORT_BOOKING_FILTER_ATTENDANCE_TYPE = 'attended';
export const EVENT_REPORT_BOOKING_FILTER_NOT_ATTENDANCE_TYPE = 'notAttended';

export const EVENT_REPORT_PRE_REGISTRATION_FILTER_STATUS_PARAM = 'status';
export const EVENT_REPORT_PRE_REGISTRATION_FILTER_CONVERTED_TYPE = 'converted';
export const EVENT_REPORT_PRE_REGISTRATION_FILTER_NOTIFIED_TYPE = 'notified';
export const EVENT_REPORT_PRE_REGISTRATION_FILTER_REGISTERED_TYPE = 'registered';

export const EVENT_REPORT_BOOKING_FILTER_OFFER_PARAM = 'offers';
export const EVENT_REPORT_BOOKING_FILTER_ADDON_PARAM = 'addOns';

export const EVENT_REPORT_ACTION_TYPE_DOWNLOAD_PDF = 'downloadPDF';
export const EVENT_REPORT_ACTION_TYPE_DISABLED = 'disabled';
export const EVENT_REPORT_ACTION_TYPE_EMPTY = 'empty';
export const EVENT_REPORT_ACTION_TYPE_REFUND = 'refund';
export const EVENT_REPORT_ACTION_TYPE_CANCEL = 'cancel';
export const EVENT_REPORT_ACTION_TYPE_RESEND_BOOKING = 'resendBooking';
export const EVENT_REPORT_ACTION_TYPE_SEE_DETAILS = 'seeDetails';

export type ChannelDataTypeTabs =
  | typeof EVENT_REPORT_TAB_TYPE_BOOKING
  | typeof EVENT_REPORT_TAB_TYPE_REVENUE
  | typeof EVENT_REPORT_TAB_TYPE_ATTENDEES
  | typeof EVENT_REPORT_TAB_PRE_REGISTRATION;

export const EVENT_REPORT_OLD_OFFER_TYPES_TRANSLATIONS: { [key: string]: string } = {
  ticket: 'eventReport:badgeTicketLabel',
  bottleService: 'eventReport:badgeBottleServiceLabel',
  guestList: 'eventReport:badgeGuestListLabel',
  seasonPass: 'eventReport:badgePassLabel',
  invitation: 'eventReport:badgeInvitationLabel',
};

/* CONFIG ANCHOR BAR */
export const HIGHLIGHTS_TAB_ID = 'highlights';
export const OFFERS_TAB_ID = 'offers';
export const BOOKINGS_TAB_ID = 'bookings';

export type TabIdType = typeof HIGHLIGHTS_TAB_ID | typeof OFFERS_TAB_ID | typeof BOOKINGS_TAB_ID;

export const HIGHLIGHTS_TAB = { name: 'eventReport:highlightsTabLabel', id: HIGHLIGHTS_TAB_ID };
export const OFFERS_TAB = { name: 'eventReport:offersTabLabel', id: OFFERS_TAB_ID };
export const BOOKINGS_TAB = { name: 'eventReport:bookingsTabLabel', id: BOOKINGS_TAB_ID };
export const EVENT_REPORT_TABS: Tab[] = [HIGHLIGHTS_TAB, OFFERS_TAB, BOOKINGS_TAB];

/* CONFIG LINEAR GRAPH */
export const BADGE_LIST_ADMISSIONS = [
  {
    id: EVENT_REPORT_TICKET_TYPE,
    title: 'eventReport:badgeTicketLabel',
    color: EVENT_REPORT_TICKET_COLOR,
  },
  {
    id: EVENT_REPORT_BOTTLE_SERVICE_TYPE,
    title: 'eventReport:badgeBottleServiceLabel',
    color: EVENT_REPORT_BOTTLE_SERVICE_COLOR,
  },
  {
    id: EVENT_REPORT_GUEST_LIST_TYPE,
    title: 'eventReport:badgeGuestListLabel',
    color: EVENT_REPORT_GUEST_LIST_COLOR,
  },
  {
    id: EVENT_REPORT_PASS_TYPE,
    title: 'eventReport:badgePassLabel',
    color: EVENT_REPORT_PASS_COLOR,
  },
  {
    id: EVENT_REPORT_INVITATION_TYPE,
    title: 'eventReport:badgeInvitationLabel',
    color: EVENT_REPORT_INVITATION_COLOR,
  },
];

const TICKET_TYPE_TABLE: TableOfferReport = {
  type: EVENT_REPORT_TICKET_TYPE,
  isDropdown: true,
  isFooterEnabled: true,
  columns: [
    {
      id: EVENT_REPORT_TABLE_NAME_COLUMN,
      dependsOn: null,
      isActive: true,
    },
    {
      id: EVENT_REPORT_TABLE_PRICE_COLUMN,
      dependsOn: null,
      isActive: true,
    },
    {
      id: EVENT_REPORT_TABLE_BOOKINGS_COLUMN,
      dependsOn: null,
      isActive: true,
    },
    {
      id: EVENT_REPORT_TABLE_STATUS_COLUMN,
      dependsOn: null,
      isActive: true,
    },
    {
      id: EVENT_REPORT_TABLE_DDP_COLUMN,
      dependsOn: null,
      isActive: true,
    },
    {
      id: EVENT_REPORT_TABLE_REVENUE_COLUMN,
      dependsOn: null,
      isActive: true,
    },
    {
      id: EVENT_REPORT_TABLE_ADDONS_COLUMN,
      dependsOn: null,
      isActive: true,
      isClickable: true,
    },
  ],
  expandColumns: [EVENT_REPORT_TABLE_ADDONS_COLUMN],
};

const BOTTLE_SERVICE_TYPE_TABLE: TableOfferReport = {
  type: EVENT_REPORT_BOTTLE_SERVICE_TYPE,
  isDropdown: true,
  isFooterEnabled: true,
  columns: [
    {
      id: EVENT_REPORT_TABLE_NAME_COLUMN,
      dependsOn: null,
      isActive: true,
    },
    {
      id: EVENT_REPORT_TABLE_PRICE_COLUMN,
      dependsOn: null,
      isActive: true,
    },
    {
      id: EVENT_REPORT_TABLE_DOWNPAYMENT_COLUMN,
      dependsOn: null,
      isActive: true,
    },
    {
      id: EVENT_REPORT_TABLE_BOOKINGS_COLUMN,
      dependsOn: null,
      isActive: true,
    },
    {
      id: EVENT_REPORT_TABLE_STATUS_COLUMN,
      dependsOn: null,
      isActive: true,
    },
    {
      id: EVENT_REPORT_TABLE_DDP_COLUMN,
      dependsOn: null,
      isActive: true,
    },
    {
      id: EVENT_REPORT_TABLE_REVENUE_COLUMN,
      dependsOn: null,
      isActive: true,
    },
    {
      id: EVENT_REPORT_TABLE_ADDONS_COLUMN,
      dependsOn: null,
      isActive: true,
      isClickable: true,
    },
  ],
  expandColumns: [EVENT_REPORT_TABLE_ADDONS_COLUMN],
};

const GUEST_LIST_TYPE_TABLE: TableOfferReport = {
  type: EVENT_REPORT_GUEST_LIST_TYPE,
  isDropdown: true,
  isFooterEnabled: true,
  columns: [
    {
      id: EVENT_REPORT_TABLE_NAME_COLUMN,
      dependsOn: null,
      isActive: true,
    },
    {
      id: EVENT_REPORT_TABLE_PRICE_COLUMN,
      dependsOn: null,
      isActive: true,
    },
    {
      id: EVENT_REPORT_TABLE_BOOKINGS_COLUMN,
      dependsOn: null,
      isActive: true,
    },
    {
      id: EVENT_REPORT_TABLE_STATUS_COLUMN,
      dependsOn: null,
      isActive: true,
    },
    {
      id: EVENT_REPORT_TABLE_DDP_COLUMN,
      dependsOn: null,
      isActive: true,
    },
    {
      id: EVENT_REPORT_TABLE_REVENUE_COLUMN,
      dependsOn: null,
      isActive: true,
    },
  ],
  expandColumns: [],
};

export const OFFER_TABLE_COLUMNS: TableOfferReport[] = [
  TICKET_TYPE_TABLE,
  BOTTLE_SERVICE_TYPE_TABLE,
  GUEST_LIST_TYPE_TABLE,
];
export const INVITATION_TABLE_COLUMNS = {
  type: EVENT_REPORT_INVITATION_TYPE,
  isDropdown: true,
  isFooterEnabled: true,
  columns: [
    {
      id: EVENT_REPORT_TABLE_NAME_COLUMN,
      dependsOn: null,
      isActive: true,
    },
    {
      id: EVENT_REPORT_TABLE_BOOKINGS_COLUMN,
      dependsOn: null,
      isActive: true,
    },
    {
      id: EVENT_REPORT_TABLE_STATUS_COLUMN,
      dependsOn: null,
      isActive: true,
    },
  ],
  expandColumns: [],
};
export const ADDONS_TABLE_COLUMNS = {
  type: EVENT_REPORT_ADDON_TYPE,
  isDropdown: true,
  isFooterEnabled: true,
  columns: [
    {
      id: EVENT_REPORT_TABLE_NAME_COLUMN,
      dependsOn: null,
      isActive: true,
    },
    {
      id: EVENT_REPORT_TABLE_PRICE_COLUMN,
      dependsOn: null,
      isActive: true,
    },
    {
      id: EVENT_REPORT_TABLE_BOOKINGS_COLUMN,
      dependsOn: null,
      isActive: true,
    },
    {
      id: EVENT_REPORT_TABLE_REVENUE_COLUMN,
      dependsOn: null,
      isActive: true,
    },
    {
      id: EVENT_REPORT_TABLE_ACTIONS_COLUMN,
      dependsOn: null,
      isActive: true,
    },
  ],
  expandColumns: [],
};

export const PASS_TABLE_COLUMNS = [
  {
    id: EVENT_REPORT_TABLE_NAME_COLUMN,
    dependsOn: null,
    isActive: true,
  },
  {
    id: EVENT_REPORT_TABLE_PRICE_COLUMN,
    dependsOn: null,
    isActive: true,
  },
  {
    id: EVENT_REPORT_TABLE_BOOKINGS_COLUMN,
    dependsOn: null,
    isActive: true,
  },
  {
    id: EVENT_REPORT_TABLE_STATUS_COLUMN,
    dependsOn: null,
    isActive: true,
  },
  {
    id: EVENT_REPORT_TABLE_REVENUE_COLUMN,
    dependsOn: null,
    isActive: true,
  },
  {
    id: EVENT_REPORT_TABLE_HOLDERS_COLUMN,
    dependsOn: null,
    isActive: true,
  },
  {
    id: EVENT_REPORT_TABLE_ACTIONS_COLUMN,
    dependsOn: null,
    isActive: true,
  },
];

export const ACTIVE_PASS_TABLE_COLUMNS = {
  type: EVENT_REPORT_ACTIVE_PASS_TYPE,
  isDropdown: true,
  isFooterEnabled: true,
  columns: PASS_TABLE_COLUMNS,
  expandColumns: [],
};

export const INACTIVE_PASS_TABLE_COLUMNS = {
  type: EVENT_REPORT_INACTIVE_PASS_TYPE,
  isDropdown: true,
  isFooterEnabled: true,
  columns: PASS_TABLE_COLUMNS,
  expandColumns: [],
};

const PAST_TICKET_TYPE_TABLE: TableOfferReport = {
  type: EVENT_REPORT_TICKET_TYPE,
  isDropdown: true,
  isFooterEnabled: true,
  columns: [
    {
      id: EVENT_REPORT_TABLE_NAME_COLUMN,
      dependsOn: null,
      isActive: true,
    },
    {
      id: EVENT_REPORT_TABLE_PRICE_COLUMN,
      dependsOn: null,
      isActive: true,
    },
    {
      id: EVENT_REPORT_TABLE_BOOKINGS_COLUMN,
      dependsOn: null,
      isActive: true,
    },
    {
      id: EVENT_REPORT_TABLE_ATTENDEES_COLUMN,
      dependsOn: null,
      isActive: true,
    },
    {
      id: EVENT_REPORT_TABLE_DDP_COLUMN,
      dependsOn: null,
      isActive: true,
    },
    {
      id: EVENT_REPORT_TABLE_REVENUE_COLUMN,
      dependsOn: null,
      isActive: true,
    },
    {
      id: EVENT_REPORT_TABLE_ADDONS_COLUMN,
      dependsOn: null,
      isActive: true,
      isClickable: true,
    },
  ],
  expandColumns: [EVENT_REPORT_TABLE_ADDONS_COLUMN],
};

const PAST_BOTTLE_SERVICE_TYPE_TABLE: TableOfferReport = {
  type: EVENT_REPORT_BOTTLE_SERVICE_TYPE,
  isDropdown: true,
  isFooterEnabled: true,
  columns: [
    {
      id: EVENT_REPORT_TABLE_NAME_COLUMN,
      dependsOn: null,
      isActive: true,
    },
    {
      id: EVENT_REPORT_TABLE_PRICE_COLUMN,
      dependsOn: null,
      isActive: true,
    },
    {
      id: EVENT_REPORT_TABLE_DOWNPAYMENT_COLUMN,
      dependsOn: null,
      isActive: true,
    },
    {
      id: EVENT_REPORT_TABLE_BOOKINGS_COLUMN,
      dependsOn: null,
      isActive: true,
    },
    {
      id: EVENT_REPORT_TABLE_ATTENDEES_COLUMN,
      dependsOn: null,
      isActive: true,
    },
    {
      id: EVENT_REPORT_TABLE_DDP_COLUMN,
      dependsOn: null,
      isActive: true,
    },
    {
      id: EVENT_REPORT_TABLE_REVENUE_COLUMN,
      dependsOn: null,
      isActive: true,
    },
    {
      id: EVENT_REPORT_TABLE_ADDONS_COLUMN,
      dependsOn: null,
      isActive: true,
      isClickable: true,
    },
  ],
  expandColumns: [EVENT_REPORT_TABLE_ADDONS_COLUMN],
};

const PAST_GUEST_LIST_TYPE_TABLE: TableOfferReport = {
  type: EVENT_REPORT_GUEST_LIST_TYPE,
  isDropdown: true,
  isFooterEnabled: true,
  columns: [
    {
      id: EVENT_REPORT_TABLE_NAME_COLUMN,
      dependsOn: null,
      isActive: true,
    },
    {
      id: EVENT_REPORT_TABLE_PRICE_COLUMN,
      dependsOn: null,
      isActive: true,
    },
    {
      id: EVENT_REPORT_TABLE_BOOKINGS_COLUMN,
      dependsOn: null,
      isActive: true,
    },
    {
      id: EVENT_REPORT_TABLE_ATTENDEES_COLUMN,
      dependsOn: null,
      isActive: true,
    },
    {
      id: EVENT_REPORT_TABLE_DDP_COLUMN,
      dependsOn: null,
      isActive: true,
    },
    {
      id: EVENT_REPORT_TABLE_REVENUE_COLUMN,
      dependsOn: null,
      isActive: true,
    },
  ],
  expandColumns: [],
};

export const PAST_OFFER_TABLE_COLUMNS: TableOfferReport[] = [
  PAST_TICKET_TYPE_TABLE,
  PAST_BOTTLE_SERVICE_TYPE_TABLE,
  PAST_GUEST_LIST_TYPE_TABLE,
];

export const PAST_INVITATION_TABLE_COLUMNS = {
  type: EVENT_REPORT_INVITATION_TYPE,
  isDropdown: true,
  isFooterEnabled: true,
  columns: [
    {
      id: EVENT_REPORT_TABLE_NAME_COLUMN,
      dependsOn: null,
      isActive: true,
    },
    {
      id: EVENT_REPORT_TABLE_BOOKINGS_COLUMN,
      dependsOn: null,
      isActive: true,
    },
    {
      id: EVENT_REPORT_TABLE_ATTENDEES_COLUMN,
      dependsOn: null,
      isActive: true,
    },
  ],
  expandColumns: [],
};

export const PAST_ADDONS_TABLE_COLUMNS = {
  type: EVENT_REPORT_ADDON_TYPE,
  isDropdown: true,
  isFooterEnabled: true,
  columns: [
    {
      id: EVENT_REPORT_TABLE_NAME_COLUMN,
      dependsOn: null,
      isActive: true,
    },
    {
      id: EVENT_REPORT_TABLE_PRICE_COLUMN,
      dependsOn: null,
      isActive: true,
    },
    {
      id: EVENT_REPORT_TABLE_BOOKINGS_COLUMN,
      dependsOn: null,
      isActive: true,
    },
    {
      id: EVENT_REPORT_TABLE_ATTENDEES_COLUMN,
      dependsOn: null,
      isActive: true,
    },
    {
      id: EVENT_REPORT_TABLE_REVENUE_COLUMN,
      dependsOn: null,
      isActive: true,
    },
    {
      id: EVENT_REPORT_TABLE_ACTIONS_COLUMN,
      dependsOn: null,
      isActive: true,
    },
  ],
  expandColumns: [],
};

export const PAST_PASS_TABLE_COLUMNS = [
  {
    id: EVENT_REPORT_TABLE_NAME_COLUMN,
    dependsOn: null,
    isActive: true,
  },
  {
    id: EVENT_REPORT_TABLE_PRICE_COLUMN,
    dependsOn: null,
    isActive: true,
  },
  {
    id: EVENT_REPORT_TABLE_BOOKINGS_COLUMN,
    dependsOn: null,
    isActive: true,
  },
  {
    id: EVENT_REPORT_TABLE_ATTENDEES_COLUMN,
    dependsOn: null,
    isActive: true,
  },
  {
    id: EVENT_REPORT_TABLE_REVENUE_COLUMN,
    dependsOn: null,
    isActive: true,
  },
  {
    id: EVENT_REPORT_TABLE_HOLDERS_COLUMN,
    dependsOn: null,
    isActive: true,
  },
  {
    id: EVENT_REPORT_TABLE_ACTIONS_COLUMN,
    dependsOn: null,
    isActive: true,
  },
];

export const PAST_ACTIVE_PASS_TABLE_COLUMNS = {
  type: EVENT_REPORT_ACTIVE_PASS_TYPE,
  isDropdown: true,
  isFooterEnabled: true,
  columns: PAST_PASS_TABLE_COLUMNS,
  expandColumns: [],
};

export const PAST_INACTIVE_PASS_TABLE_COLUMNS = {
  type: EVENT_REPORT_INACTIVE_PASS_TYPE,
  isDropdown: true,
  isFooterEnabled: true,
  columns: PAST_PASS_TABLE_COLUMNS,
  expandColumns: [],
};

/* CONFIG CHANNEL TABLE */
export const BADGES_CHECKIN_LIST = [
  {
    id: EVENT_REPORT_CHECKIN_TYPE,
    title: 'eventReport:checkin',
    color: EVENT_REPORT_CHECKIN_COLOR,
  },
  ...BADGE_LIST_ADMISSIONS,
];

export const PAST_CHANNEL_TABLE_COLUMNS = [
  {
    id: EVENT_REPORT_TABLE_CHANNELS_COLUMN,
    dependsOn: null,
    isActive: true,
  },
  {
    id: EVENT_REPORT_TABLE_ATTENDEES_COLUMN,
    dependsOn: null,
    isActive: true,
  },
  {
    id: EVENT_REPORT_TABLE_TOTAL_COLUMN,
    dependsOn: null,
    isActive: true,
  },

  {
    id: EVENT_REPORT_TABLE_CONVERSION_COLUMN,
    dependsOn: null,
    isActive: true,
  },
  {
    id: EVENT_REPORT_TICKET_TYPE,
    dependsOn: null,
    isActive: true,
    isClickable: true,
  },
  {
    id: EVENT_REPORT_BOTTLE_SERVICE_TYPE,
    dependsOn: null,
    isActive: true,
    isClickable: true,
  },
  {
    id: EVENT_REPORT_GUEST_LIST_TYPE,
    dependsOn: null,
    isActive: true,
    isClickable: true,
  },
  {
    id: EVENT_REPORT_PASS_TYPE,
    dependsOn: null,
    isActive: true,
    isClickable: true,
  },
  {
    id: EVENT_REPORT_INVITATION_TYPE,
    dependsOn: null,
    isActive: true,
    isClickable: true,
  },
  {
    id: EVENT_REPORT_CHECKIN_TYPE,
    dependsOn: null,
    isActive: true,
  },
];

export const CHANNEL_TABLE_COLUMNS = [
  {
    id: EVENT_REPORT_TABLE_CHANNELS_COLUMN,
    dependsOn: null,
    isActive: true,
  },
  {
    id: EVENT_REPORT_TABLE_TOTAL_COLUMN,
    dependsOn: null,
    isActive: true,
  },
  {
    id: EVENT_REPORT_TICKET_TYPE,
    dependsOn: null,
    isActive: true,
    isClickable: true,
  },
  {
    id: EVENT_REPORT_BOTTLE_SERVICE_TYPE,
    dependsOn: null,
    isActive: true,
    isClickable: true,
  },
  {
    id: EVENT_REPORT_GUEST_LIST_TYPE,
    dependsOn: null,
    isActive: true,
    isClickable: true,
  },
  {
    id: EVENT_REPORT_PASS_TYPE,
    dependsOn: null,
    isActive: true,
    isClickable: true,
  },
  {
    id: EVENT_REPORT_INVITATION_TYPE,
    dependsOn: null,
    isActive: true,
    isClickable: true,
  },
];

export const CHANNEL_TABLE_COLUMNS_REVENUE = [
  {
    id: EVENT_REPORT_TABLE_CHANNELS_COLUMN,
    dependsOn: null,
    isActive: true,
  },
  {
    id: EVENT_REPORT_TABLE_TOTAL_COLUMN,
    dependsOn: null,
    isActive: true,
  },
  {
    id: EVENT_REPORT_TABLE_REVENUE_PER_BOOKING_COLUMN,
    dependsOn: null,
    isActive: true,
  },
  {
    id: EVENT_REPORT_TICKET_TYPE,
    dependsOn: null,
    isActive: true,
    isClickable: true,
  },
  {
    id: EVENT_REPORT_BOTTLE_SERVICE_TYPE,
    dependsOn: null,
    isActive: true,
    isClickable: true,
  },
  {
    id: EVENT_REPORT_GUEST_LIST_TYPE,
    dependsOn: null,
    isActive: true,
    isClickable: true,
  },
  {
    id: EVENT_REPORT_PASS_TYPE,
    dependsOn: null,
    isActive: true,
    isClickable: true,
  },
  {
    id: EVENT_REPORT_INVITATION_TYPE,
    dependsOn: null,
    isActive: true,
    isClickable: true,
  },
];

export const CHANNEL_TABLE_COLUMNS_PRE_REGISTRATION = [
  {
    id: EVENT_REPORT_TABLE_CHANNELS_COLUMN,
    dependsOn: null,
    isActive: true,
  },
  {
    id: EVENT_REPORT_TABLE_SIGNUPS_COLUMN,
    dependsOn: null,
    isActive: true,
  },
  {
    id: EVENT_REPORT_TABLE_BOOKINGS_COLUMN,
    dependsOn: null,
    isActive: true,
  },
  {
    id: EVENT_REPORT_TABLE_CONVERSION_RATE_COLUMN,
    dependsOn: null,
    isActive: true,
  },
];

export const PRE_REGISTRATION_SECTION_TABLE = [
  {
    id: EVENT_REPORT_TABLE_SIGNUPS_COLUMN,
    dependsOn: null,
    isActive: true,
  },
  {
    id: EVENT_REPORT_TABLE_STATUS_COLUMN,
    dependsOn: null,
    isActive: true,
  },
  {
    id: EVENT_REPORT_TABLE_UNIQUE_BOOKINGS_COLUMN,
    dependsOn: null,
    isActive: true,
    title: 'eventReport:uniqueBookings',
  },
  {
    id: EVENT_REPORT_TABLE_TOTAL_BOOKINGS_COLUMN,
    dependsOn: null,
    isActive: true,
    title: 'eventReport:totalBookings',
  },
  {
    id: EVENT_REPORT_TABLE_CONVERSION_RATE_COLUMN,
    dependsOn: null,
    isActive: true,
  },
];

export const EVENT_REPORT_BARCHART_CONFIG: BarchartData = {
  dataKey: 'channel',
  layout: RECHART_LAYOUT_VERTICAL,
  gridColor: 'var(--tick-fill-color-secondary)',
  strokeDasharray: '8 8',
  axisLineX: false,
  tickLineX: false,
  axisLineY: false,
  tickLineY: false,
  horizontalGridLines: false,
  barGapColor: '#fff',
  barHeight: 26,
  barBorderRadius: 6,
  barBorderWidth: 2,
  barGapY: 32,
  rechartFontSizeLg: 16,
  rechartFontSizeXs: 12,
  rechartSubtitleFontSize: 12,
  labelTruncateLength: 12,
};

export const CHANNEL_DATA_TYPE_TABS: EventReportTab[] = [
  {
    id: EVENT_REPORT_TAB_TYPE_BOOKING,
    name: 'analytics:titleSoldItems',
  },
  {
    id: EVENT_REPORT_TAB_TYPE_REVENUE,
    name: 'eventReport:revenueTabLabel',
  },
  {
    id: EVENT_REPORT_TAB_PRE_REGISTRATION,
    name: 'preRegistration:title',
  },
];

export const PAST_CHANNEL_DATA_TYPE_TABS: EventReportTab[] = [
  {
    id: EVENT_REPORT_TAB_TYPE_BOOKING,
    name: 'analytics:titleSoldItems',
  },
  {
    id: EVENT_REPORT_TAB_TYPE_REVENUE,
    name: 'eventReport:revenueTabLabel',
  },
  {
    id: EVENT_REPORT_TAB_TYPE_ATTENDEES,
    name: 'eventReport:attendeesLabel',
  },
  {
    id: EVENT_REPORT_TAB_PRE_REGISTRATION,
    name: 'preRegistration:title',
  },
];

export const CHANNEL_MODE_TYPE_TABS: EventReportTab[] = [
  {
    id: EVENT_REPORT_MODE_TYPE_GRAPH,
    name: EVENT_REPORT_MODE_TYPE_GRAPH,
  },
  {
    id: EVENT_REPORT_MODE_TYPE_LIST,
    name: EVENT_REPORT_MODE_TYPE_LIST,
  },
];

/* CONFIG BOOKING SECTION */
export const PRE_REGISTRATION_TABLE_COLUMNS = [
  {
    id: EVENT_REPORT_TABLE_PREGISTRATION_NAME_COLUMN,
    label: 'eventReport:customerNameColumnTitle',
    isClickable: true,
  },
  {
    id: EVENT_REPORT_TABLE_TIME_COLUMN,
    label: 'eventReport:customerTimeColumnTitle',
    isClickable: true,
  },
  {
    id: EVENT_REPORT_TABLE_PRE_REGISTRATION_STATUS_COLUMN,
    label: 'eventReport:statusLabel',
    isClickable: false,
  },
  {
    id: EVENT_REPORT_TABLE_BOOKINGS_COLUMN,
    label: 'eventReport:bookingTitle',
    isClickable: true,
  },
  {
    id: EVENT_REPORT_TABLE_CHANNELS_COLUMN,
    label: 'eventReport:channelColumnLabel',
    isClickable: false,
  },
];

export const BOOKING_TABLE_COLUMNS = [
  {
    id: EVENT_REPORT_TABLE_NAME_COLUMN,
    label: 'eventReport:customerNameColumnTitle',
    isClickable: true,
  },
  {
    id: EVENT_REPORT_TABLE_OFFER_COLUMN,
    label: 'eventReport:customerOfferColumnTitle',
    isClickable: false,
  },
  {
    id: EVENT_REPORT_TABLE_QUANTITY_COLUMN,
    label: 'eventReport:customerQuantityColumnTitle',
    isClickable: true,
  },
  {
    id: EVENT_REPORT_TABLE_PRICE_COLUMN,
    label: 'eventReport:customerPriceColumnTitle',
    isClickable: false,
  },
  {
    id: EVENT_REPORT_TABLE_TIME_COLUMN,
    label: 'eventReport:customerTimeColumnTitle',
    isClickable: true,
  },
  {
    id: EVENT_REPORT_TABLE_STATUS_COLUMN,
    label: 'eventReport:statusLabel',
    isClickable: false,
  },
  {
    id: EVENT_REPORT_TABLE_ADDONS_COLUMN,
    label: 'eventReport:customerAddonsColumnTitle',
    isClickable: false,
  },
  {
    id: EVENT_REPORT_TABLE_ACTIONS_COLUMN,
    label: '',
    isClickable: false,
  },
];

export const PAST_BOOKING_TABLE_COLUMNS = [
  {
    id: EVENT_REPORT_TABLE_NAME_COLUMN,
    label: 'eventReport:customerNameColumnTitle',
    isClickable: true,
  },
  {
    id: EVENT_REPORT_TABLE_OFFER_COLUMN,
    label: 'eventReport:customerOfferColumnTitle',
    isClickable: false,
  },
  {
    id: EVENT_REPORT_TABLE_QUANTITY_COLUMN,
    label: 'eventReport:customerQuantityColumnTitle',
    isClickable: true,
  },
  {
    id: EVENT_REPORT_TABLE_PRICE_COLUMN,
    label: 'eventReport:customerPriceColumnTitle',
    isClickable: false,
  },
  {
    id: EVENT_REPORT_TABLE_TIME_COLUMN,
    label: 'eventReport:customerTimeColumnTitle',
    isClickable: true,
  },
  {
    id: EVENT_REPORT_TABLE_STATUS_COLUMN,
    label: 'eventReport:statusLabel',
    isClickable: false,
  },
  {
    id: EVENT_REPORT_TABLE_ATTENDEES_COLUMN,
    label: 'eventReport:attendeesLabel',
    isClickable: false,
  },
  {
    id: EVENT_REPORT_TABLE_ADDONS_COLUMN,
    label: 'eventReport:customerAddonsColumnTitle',
    isClickable: false,
  },
  {
    id: EVENT_REPORT_TABLE_ACTIONS_COLUMN,
    label: '',
    isClickable: false,
  },
];

export const BOOKING_FILTER_ORDER = [
  ADMISSION_TYPE_TICKET,
  ADMISSION_TYPE_BOTTLE_SERVICE,
  ADMISSION_TYPE_GUEST_LIST,
  ADMISSION_TYPE_SEASON_PASS,
  ADMISSION_TYPE_INVITATION,
];
